import React from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";

export default function CustomEnhancements() {

  const scrollToSection = (e, targetId) => {
    e.preventDefault();

    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 150, // Adjust the offset based on your layout
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="enhancements">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          //   data-background="assets/img/breadcrumb/Custom-Enhancements.png"
          style={{
            backgroundImage:
              'url("assets/img/breadcrumb/Custom-Enhancements.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Custom <br /> Enhancements
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        <div className="section">
          <div className="border-top-1 d-none d-lg-block text-center">
            <div className="container">
              <ul className="list-inline d-flex align-items-center mb-0">
                <li className="list-inline-item">
                  <a
                    href="#framesSection"
                    onClick={(e) => scrollToSection(e, "framesSection")}
                    className="text-reset d-inline-block px-4 py-3 fw-600 text-primary-grad opacity-100"
                  >
                    <i className="las la-tachometer-alt mr-1" />
                    <span>FRAMES</span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="#metallicWrapsSection"
                    onClick={(e) => scrollToSection(e, "metallicWrapsSection")}
                    className="text-reset d-inline-block px-4 py-3 fw-600 "
                  >
                    <i className="las la-user mr-1" />
                    <span>Metallic wraps</span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="#handEmbelSection"
                    onClick={(e) => scrollToSection(e, "handEmbelSection")}
                    className="text-reset d-inline-block px-4 py-3 fw-600 "
                  >
                    <i className="la la-heart-o mr-1" />
                    <span>HAND EMBELLISHMENTS</span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    href="#artTraySection"
                    onClick={(e) => scrollToSection(e, "artTraySection")}
                    className="text-reset d-inline-block px-4 py-3 fw-600 "
                  >
                    <i className="las la-list mr-1" />
                    <span>ART TRAY</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* second content section start*/}
        <div
          id="framesSection"
          className="tp-blog__area p-relative pt-110  gallery-hero"
          data-background="assets/img/breadcrumb/Enhancements-12.png"
          style={{
            backgroundImage: "url('assets/img/breadcrumb/Enhancements-12.png')",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-6 text-center ">
                <h4 className="text-left">Frames</h4>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-12 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/floating-frames.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content text-center">
                    <h5 className="tp-blog__title">
                      <Link>FLOATING FRAMES</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Floating frames ass a modern look to your gallery
                        wrapped canvas. An .75” or 1.50” gallery wrap canvas is
                        set into this frame, leaving a 3/8” reveal space between
                        the canvas and frame.
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link>Shop Floating Frames</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-lg-6 col-md-12 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/floating-frames-right.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__conten text-center">
                    <h5 className="tp-blog__title">
                      <Link>PREMIUM FRAMES</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Canvas is wrapped around a 1.5″ thick wood stretcher
                        bar. This choice creates an artistic look that enhances
                        your image and does not need a frame.
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link>Shop Premium Frames</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* second content section end */}
        {/* wrapped section start */}
        <div
          id="metallicWrapsSection"
          className="tp-blog__area p-relative pt-110 pb-100 gallery-hero"
          data-background="assets/img/breadcrumb/routing.png"
          style={{
            backgroundImage: "url('assets/img/breadcrumb/routing.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-12 text-center mb-30">
                <h4 className="text-left">Metalic Wraps</h4>
                <p className="w-50 m-auto">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  molestie felis sit amet augue tincidunt gravida. Integer
                  semper nisl quis convallis euismod. Nullam ut nunc vestibulum,
                  pulvinar ante sed, convallis sapien.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-12   wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/Metalic-Wraps-1.png"
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-lg-6 col-md-12   wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/Metalic-Wraps-2.png"
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="text-center mt-60 button-uper">
                <Link className="  large head banner">Add METALIC WRAP</Link>
              </div>
            </div>
          </div>
        </div>
        {/* wraped section section end */}
        {/* third wrapped section start */}
        <div
          id="handEmbelSection"
          className="tp-blog__area p-relative pt-30 pb-80 gallery-hero"
        >
          <div className="container">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-12 text-center mb-30">
                <h4 className="text-left">Hand Embellishment</h4>
                <p className="w-50 m-auto">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  molestie felis sit amet augue tincidunt gravida. Integer
                  semper nisl quis convallis euismod. Nullam ut nunc vestibulum,
                  pulvinar ante sed, convallis sapien.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-12   wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/Embellishment-1.png"
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-lg-6 col-md-12   wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/Embellishment-2.png"
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="text-center mt-60 button-uper">
                <Link className="  large head banner">
                  Add HAND EMBELLISHMENT
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* art wrapped section end */}
        <div
          id="artTraySection"
          className="tp-blog__area p-relative pt-30 pb-100 gallery-hero"
          data-background="assets/img/breadcrumb/Group.png"
          style={{
            backgroundImage: "url('assets/img/breadcrumb/Group.png')",
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <div className="row text">
              <div className="col-xl-12 col-lg-12 col-md-12 text-center mb-30">
                <h4 className="text-left">Art Tray</h4>
                <p className="w-50 m-auto">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  molestie felis sit amet augue tincidunt gravida. Integer
                  semper nisl quis convallis euismod. Nullam ut nunc vestibulum,
                  pulvinar ante sed, convallis sapien.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-12   wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/art-1.png"
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-lg-6 col-md-12   wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link>
                      <img
                        className="w-100"
                        src="assets/img/blog/art-2.png"
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="text-center mt-60 button-uper">
                <Link to={""} className="  large head banner">
                  Print ART TRAY
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* art wrapped section start */}

        <UpperFooterSlider />
      </main>
    </div>
  );
}
